<div class="dialog-header">
  <h3>{{ "send-email" | translate }}</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form [formGroup]="emailForm">
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "subject" | translate }}</mat-label>
        <input
          formControlName="subject"
          matInput
          id="emailForm-form-input-subject"
        />
        <mat-error
          *ngIf="
            emailForm.get('subject').touched &&
            emailForm.get('subject').hasError('required')
          "
          >{{ "required-subject" | translate }}</mat-error
        >
      </mat-form-field>
    </div>
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "title" | translate }}</mat-label>
        <input
          formControlName="title"
          matInput
          id="emailForm-form-input-email"
        />
        <mat-error
          *ngIf="
            emailForm.get('title').touched &&
            emailForm.get('title').hasError('required')
          "
          >{{ "required-title" | translate }}</mat-error
        >
      </mat-form-field>
    </div>
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-message" | translate }}</mat-label
        ><textarea
          formControlName="message"
          matInput
          id="emailForm-form-input-message"
        ></textarea>
        <mat-error
          *ngIf="
            emailForm.get('message').touched &&
            emailForm.get('message').hasError('required')
          "
          >{{ "required-message" | translate }}</mat-error
        >
      </mat-form-field>
    </div>
    <div class="row-fx-legacy">
      <button
        type="button"
        class="attach-files-button"
        mat-raised-button
        color="primary"
        (click)="inputFile.click()"
        id="emailForm-form-button-sendEmail"
      >
        <i class="bosch-ic bosch-ic-paperclip"></i>
        {{ "attach-files" | translate }}
      </button>
      <input
        type="file"
        #inputFile
        hidden
        formControlName="listAttachment"
        (change)="onFilesChange($event)"
        multiple
        id="emailForm-form-input-files"
      />
    </div>
    <mat-error
      *ngIf="
        emailForm.get('listAttachment').touched &&
        emailForm.get('listAttachment').hasError('max-files-size')
      "
      >{{ "maximum-size-reached-5mb" | translate }}</mat-error
    >
    <div class="row-fx-legacy">
      <mat-list>
        <mat-list-item *ngFor="let file of files" class="file-list-item">
          {{ file.name }} - {{ file.size | bytes }}
        </mat-list-item>
      </mat-list>
    </div>
  </form>
</div>
<div class="dialog-actions">
  <button
    [disabled]="emailForm.invalid"
    mat-raised-button
    color="primary"
    (click)="sendEmail()"
  >
    {{ "button-send" | translate }}
  </button>
</div>
